import React, { useCallback } from 'react';

import { useField, useFormikContext } from 'formik';
import TextField from '..';


const TextFieldMemo = React.memo(TextField);

const TextFieldCFormik = (props) => {
	const { name, value, onChange, onBlur, ...rest } = props;
	const [field, meta] = useField(name);
	const { setFieldValue } = useFormikContext();

	const handleChange = useCallback(
		(e) => {
			const newValue = e?.target?.value ?? e;
			setFieldValue(name, newValue);
		},
		[name, setFieldValue],
	);

	if (!name) return 'For TextField connected to Formik name is required!';

	return (
		<TextFieldMemo
			{...rest}
			name={name}
			value={field.value ?? ''}
			onChange={handleChange}
			onBlur={field.onBlur}
			error={(meta.touched || meta.initialTouched) && meta.error}
		/>
	);
};

TextFieldCFormik.propTypes = {
	...TextField.propTypes,
};

export default TextFieldCFormik;
